// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { createContext } from 'react';
import { ChannelType, MemberRole } from '@/models';
import { emptyFn } from '@/lib/utils.ts';

export interface ScreenShareState {
  isSharing: boolean;
}

interface CallContextType {
  activeCall: any;

  startCall: (call: Call) => void;
  endCall: () => void;

  toggleDock: () => void;
  docked: boolean;
  setDocked: (docked: boolean) => void;

  goToCall: () => void;
  isCurrentPageActiveCall: () => boolean;

  microphoneActive: boolean;
  setMicrophoneActive: (active: boolean) => void;

  volume: number;
  setVolume: (volume: number) => void;

  endCallClicked: boolean;
  setEndCallClicked: (endCall: boolean) => void;

  kickUser: (userId: string, channelId: string, serverId: string) => void;
  resetCallState: () => void;

  screenShare: ScreenShareState;
  setScreenSharing: (active: boolean) => void;
}

export const CallContext = createContext<CallContextType>({
  activeCall: undefined,
  startCall: emptyFn,
  endCall: emptyFn,

  toggleDock: emptyFn,
  docked: false,  // means in Full page call
  setDocked: emptyFn,

  goToCall: emptyFn,
  isCurrentPageActiveCall: emptyFn,

  microphoneActive: true,
  setMicrophoneActive: emptyFn,

  volume: 100,
  setVolume: emptyFn,

  endCallClicked: false,
  setEndCallClicked: emptyFn,

  kickUser: emptyFn,
  resetCallState: emptyFn,

  screenShare: { isSharing: false },
  setScreenSharing: emptyFn,
});

/***
 Call state
 @public
 ***/
export interface Call {
  token?: string;
  tkitServerUrl?: string;
  tkitServerId?: string;
  tkitServerName?: string;
  serverId: string;
  chatId: string;
  userId: string;
  serverOwnerId: string;
  channelName?: string;
  channelType: ChannelType;
  private: boolean;
  serverName?: string;
  video: boolean;
  audio: boolean;
  role: MemberRole;
  avatar?: string;
  name?: string; // user name
  endCallClicked?: boolean;
}
